import { get } from "app/utils/axios/kheti";
import { GetUserImageResponse } from "../models/diagnosis";

const getUserUploadedImage = async (
  plantixId: string
): Promise<string | null> => {
  try {
    const response = await get<GetUserImageResponse>(
      `/plantix/v1/${plantixId}/image`
    );
    return response.image;
  } catch (e) {
    return null;
  }
};

export default getUserUploadedImage;
